import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import cutileiApi from '../../../services/cutileiApi'
import AuthService from '../../../services/auth'
import Navbar from '../../../components/Navbar'
import RatingList from '../../../components/Lists/RatingList'
import { ReactComponent as Loading } from '../../../icons/loading2.svg'
import { Container, Title } from '../styles'

function BusinessRatings () {
  const [loading, setLoading] = useState (true)
  const [businessRatings, setBusinessRatings] = useState ([])
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getBusinesses ()
  }, [])

  const getBusinesses = async () => {
    try {
      setLoading (true)
      const { data: businessRatings } = await cutileiApi.get (
        `/businesses/${businessId}/ratings`, requestConfig
      )
      setBusinessRatings (businessRatings)
    } catch (error) {
      console.log (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Container>
      <Navbar/>
      <Title>Suas avaliações</Title>
      {loading ? <Loading/> :
        <RatingList ratings={businessRatings}/>
      }
    </Container>
  )
}

export default withRouter (BusinessRatings)
